import Vue from 'vue';
import localdataService from '../services/localdata.service';

const flags = {
    en: 'us',
    fr: 'fr',
    es: 'es',
    ru: 'ru',
    zh_CN: 'cn',
    he: 'il',
    ar: 'ar',
    uz: 'uz'
};

const locales = { en: 'en-US', fr: 'fr-FR', es: 'es-ES', ru: 'ru-RU', zh_CN: 'zh-CN', he: 'he-IL', ar: 'ar-AE', 'uz': 'uz-Latn-UZ' };

const defaultFallbackLanguage = 'en';
const langDescriptions = {
    'en': 'English',
    'fr': 'Français',
    'es': 'Español',
    'ru': 'Русский',
    'zh_CN': '汉语',
    'he': 'עברית',
    'ar': 'العربية',
    'uz': 'O\'zbek'
};

const initVuexState = function(state) {};

const initGetters = function(getters) {};

const initActions = function(actions) {};

const initMutations = function(mutations) {};

const initAppState = function(appState, store) {
    let langState = {
        get currentLang() {
            return Vue.i18n
                ? Vue.i18n.locale()
                : '';
        },
        set currentLang(lang) {
            const sanitizedLang = sanitizeLang(lang);
            localdataService.set('lang', sanitizedLang);
            Vue.i18n.set(sanitizedLang);
            langState.currentLocale = locales[sanitizedLang];
        },
        ensureLocalLangOrPlayer(lang) {
            langState.currentLang = getLangOrDefault(lang);
        },
        get availableLanguages() {
            return Vue.i18n
                ? Vue.i18n.locales()
                : [];
        },
        set availableLanguages(newLocales) {
            const lang = Vue.i18n.locale();
            Vue.i18n.set('en');
            Vue.i18n.locales().forEach(l => {
                if (!newLocales.includes(l)) {
                    Vue.i18n.remove(l);
                }
            });
            langState.currentLang = lang;
        },
        flags: flags,
        langDescriptions: langDescriptions
    };

    appState.lang = langState;
};

function getLangOrDefault(lang) {
    return sanitizeLang(localdataService.get('lang') || lang || defaultFallbackLanguage);
}

function sanitizeLang(lang) {
    if (lang && Vue.i18n.locales().includes(lang)) return lang;
    return defaultFallbackLanguage;
}

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};



// WEBPACK FOOTER //
// ./_common/data/lang.js